import HeaderComponent from "../HeaderComponent";
import SectionComponent from "../SectionComponent";
import ImageComponent from "../ImageComponent";
import NavigationContainerComponent from "../NavigationContainerComponent";
import NavItemComponent from "../NavItemComponent";
import CartComponent from "../CartComponent";
import InnerSectionComponent from "../InnerSectionComponent";
import TextComponent from "../TextComponent";
import ButtonComponent from "../ButtonComponent";
import EventComponent from "../Events/EventComponent";
import FooterComponent from "../FooterComponent";
import Checkout from "../Checkout/Checkout";

export var defaultComponents: { [key: string]: any } = {
  header: HeaderComponent,
  section: SectionComponent,
  image: ImageComponent,
  "navigation-container": NavigationContainerComponent,
  "nav-item": NavItemComponent,
  cart: CartComponent,
  inner_section: InnerSectionComponent,
  text: TextComponent,
  Button: ButtonComponent,
  eventComponent: EventComponent,
  footer: FooterComponent,
  Checkout: Checkout,
};
